// import React, { useState } from "react";
// import axios from "axios";
// import toast from "react-hot-toast";

// // Header-level columns for the detail panel / edit modal — shared so both the
// // main grid and the History page render/edit the exact same fields.
// export const HEADER_COLUMNS = [
//   { key: "invoice_no",          label: "Invoice No.",            section: "Invoice" },
//   { key: "invoice_date",        label: "Invoice Date",           section: "Invoice" },
//   { key: "bill_no",             label: "Bill No.",               section: "Invoice" },
//   { key: "contract_no",         label: "Contract No.",           section: "Invoice" },
//   { key: "contract_date",       label: "Contract Date",          section: "Invoice" },
//   { key: "delivery_order_no",   label: "Delivery Order No.",     section: "Invoice" },
//   { key: "buyer_order_no",      label: "Buyer/Broker Order No.", section: "Invoice" },
//   { key: "buyer_order_date",    label: "Buyer Order Date",       section: "Invoice" },
//   { key: "seller_name",         label: "Seller / Vendor",        section: "Seller" },
//   { key: "seller_address",      label: "Seller Address",         section: "Seller" },
//   { key: "seller_gst",          label: "Seller GSTIN",           section: "Seller" },
//   { key: "seller_pan",          label: "Seller PAN",             section: "Seller" },
//   { key: "cin_no",              label: "CIN No.",                section: "Seller" },
//   { key: "seller_msme",         label: "Seller MSME / Udyam No.", section: "Seller" },
//   { key: "seller_contact_no",   label: "Seller Contact No.",     section: "Seller" },
//   { key: "seller_email",        label: "Seller Email",           section: "Seller" },
//   { key: "seller_website",      label: "Seller Website",         section: "Seller" },
//   { key: "buyer_name",          label: "Buyer",                  section: "Buyer" },
//   { key: "buyer_address",       label: "Buyer Address",          section: "Buyer" },
//   { key: "buyer_gst",           label: "Buyer GSTIN",            section: "Buyer" },
//   { key: "buyer_pan",           label: "Buyer PAN",              section: "Buyer" },
//   { key: "buyer_msme",          label: "Buyer MSME / Udyam No.", section: "Buyer" },
//   { key: "buyer_contact_no",    label: "Buyer Contact No.",      section: "Buyer" },
//   { key: "buyer_email",         label: "Buyer Email",            section: "Buyer" },
//   { key: "buyer_website",       label: "Buyer Website",          section: "Buyer" },
//   { key: "seller_bank_name",          label: "Bank Name",              section: "Seller Bank" },
//   { key: "seller_bank_account_name",  label: "Account Holder Name",    section: "Seller Bank" },
//   { key: "seller_bank_account_no",    label: "Account Number",         section: "Seller Bank" },
//   { key: "seller_bank_ifsc",          label: "IFSC Code",              section: "Seller Bank" },
//   { key: "seller_bank_swift",         label: "SWIFT Code",             section: "Seller Bank" },
//   { key: "seller_bank_address",       label: "Bank Address",           section: "Seller Bank" },
//   { key: "seller_bank_contact",       label: "Bank Contact No.",       section: "Seller Bank" },
//   { key: "buyer_bank_name",          label: "Bank Name",              section: "Buyer Bank" },
//   { key: "buyer_bank_account_name",  label: "Account Holder Name",    section: "Buyer Bank" },
//   { key: "buyer_bank_account_no",    label: "Account Number",         section: "Buyer Bank" },
//   { key: "buyer_bank_ifsc",          label: "IFSC Code",              section: "Buyer Bank" },
//   { key: "buyer_bank_swift",         label: "SWIFT Code",             section: "Buyer Bank" },
//   { key: "buyer_bank_address",       label: "Bank Address",           section: "Buyer Bank" },
//   { key: "buyer_bank_contact",       label: "Bank Contact No.",       section: "Buyer Bank" },
//   { key: "consignee_name",      label: "Consignee",              section: "Consignee" },
//   { key: "consignee_address",   label: "Consignee Address",      section: "Consignee" },
//   { key: "terms_of_payment",    label: "Terms of Payment",       section: "Terms" },
//   { key: "terms_of_delivery",   label: "Terms of Delivery",      section: "Terms" },
//   { key: "place_of_supply",     label: "Place of Supply",        section: "Terms" },
//   { key: "irn_no",              label: "IRN No.",                section: "Terms" },
//   { key: "e_way_bill_no",       label: "E-Way Bill No.",         section: "Terms" },
//   { key: "e_way_bill_validity", label: "E-Way Bill Validity",    section: "Terms" },
//   { key: "vehicle_no",          label: "Vehicle / Truck No.",    section: "Transport" },
//   { key: "dc_no",               label: "DC No.",                 section: "Transport" },
//   { key: "rr_lr_no",            label: "RR / LR No.",            section: "Transport" },
//   { key: "total_inr_figures",   label: "Total INR (Figures)",    section: "Amount" },
//   { key: "amount_words",        label: "Amount (Words)",         section: "Amount" },
//   { key: "discount_percent",    label: "Discount (%)",           section: "Amount" },
//   { key: "cgst_percent",        label: "CGST (%)",               section: "Amount" },
//   { key: "cgst_amount",         label: "CGST Amount",            section: "Amount" },
//   { key: "sgst_percent",        label: "SGST (%)",               section: "Amount" },
//   { key: "sgst_amount",         label: "SGST Amount",            section: "Amount" },
//   { key: "igst_percent",        label: "IGST (%)",               section: "Amount" },
//   { key: "igst_amount",         label: "IGST Amount",            section: "Amount" },
//   { key: "total_gst_amount",    label: "Total GST Amount",       section: "Amount" },
//   { key: "uploaded_by",         label: "Uploaded By",            section: "Audit" },
//   { key: "uploaded_time_ist",   label: "Uploaded Time (IST)",    section: "Audit" },
// ];

// export const SECTIONS = ["Invoice", "Seller", "Seller Bank", "Buyer", "Buyer Bank", "Consignee", "Terms", "Transport", "Amount", "Audit"];

// // ── CSV helpers ────────────────────────────────────────────────────────────────

// export function downloadBlob(blob, filename) {
//   const url = URL.createObjectURL(blob);
//   const a = document.createElement("a");
//   a.href = url;
//   a.download = filename;
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
//   URL.revokeObjectURL(url);
// }

// export function invoicesToFlatCsv(invoices) {
//   const hdrKeys  = HEADER_COLUMNS.map(c => c.key); // already excludes id
//   const itemKeys = [
//     "hsn_code", "material_code", "description", "quantity", "quantity_unit", "rate", "amount",
//     "cgst_percent", "cgst_amount", "sgst_percent", "sgst_amount",
//     "igst_percent", "igst_amount", "discount_percent", "discount_amount",
//   ]; // excludes id, invoice_id
//   const allKeys  = [...hdrKeys, "discounts_summary", ...itemKeys];
//   const header   = allKeys.map(k => `"${k}"`).join(",");

//   const flattenDiscounts = (inv) => {
//     try {
//       const list = inv.discounts_json ? JSON.parse(inv.discounts_json) : [];
//       if (!list.length) return "";
//       return list.map(d => `${d.label || "Discount"}: ${d.percent ? d.percent + "%" : ""}${d.amount ? ` (${d.amount})` : ""}`).join(" | ");
//     } catch {
//       return "";
//     }
//   };

//   const lines = [];
//   for (const inv of invoices) {
//     const items = inv.items?.length ? inv.items : [{}];
//     const discountsSummary = flattenDiscounts(inv);
//     for (const item of items) {
//       const row = allKeys.map(k => {
//         if (k === "discounts_summary") return `"${discountsSummary.replace(/"/g, '""')}"`;
//         const v = k in item ? item[k] : inv[k];
//         return `"${String(v ?? "").replace(/"/g, '""')}"`;
//       });
//       lines.push(row.join(","));
//     }
//   }
//   return new Blob(["\uFEFF" + [header, ...lines].join("\n")], { type: "text/csv" });
// }

// export function exportSingleInvoice(row) {
//   const blob = invoicesToFlatCsv([row]);
//   const safe = (row.invoice_no || `invoice_${row.id}`).replace(/[^a-z0-9]/gi, "_").slice(0, 40);
//   downloadBlob(blob, `${safe}_${Date.now()}.csv`);
//   toast.success(`Exported invoice ${row.invoice_no || row.id}`);
// }

// export function exportSellerInvoices(sellerName, sellerRows) {
//   const blob = invoicesToFlatCsv(sellerRows);
//   const safe = sellerName.replace(/[^a-z0-9]/gi, "_").slice(0, 40);
//   downloadBlob(blob, `invoices_${safe}_${Date.now()}.csv`);
//   toast.success(`Exported ${sellerRows.length} invoice(s) for ${sellerName}`);
// }

// // ── Date helpers ───────────────────────────────────────────────────────────────

// const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// export function parseInvoiceDate(str) {
//   if (!str) return null;
//   const s = String(str).trim();
//   let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
//   if (m) return { y: +m[1], mo: +m[2] };
//   m = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})/);
//   if (m) {
//     const a = +m[1], b = +m[2];
//     if (a > 12) return { y: +m[3], mo: b };
//     return { y: +m[3], mo: a };
//   }
//   return null;
// }

// export function getRowMonthKey(row) {
//   const d = parseInvoiceDate(row.invoice_date) || parseInvoiceDate(row.created_at);
//   if (!d) return null;
//   return `${d.y}-${String(d.mo).padStart(2, "0")}`;
// }

// export function monthKeyLabel(key) {
//   const [y, m] = key.split("-").map(Number);
//   return `${MONTH_NAMES[m - 1]} ${y}`;
// }

// // Formats a stored invoice_date (which may already be in several different
// // formats — YYYY-MM-DD, DD.MM.YYYY, DD/MM/YYYY, etc., since it comes straight
// // from whatever the source PDF/model produced) into a consistent DD/MM/YYYY
// // for display. Falls back to the raw string if it doesn't recognize the
// // pattern, rather than hiding a date the user can still read.
// export function formatInvoiceDateDMY(str) {
//   if (!str) return null;
//   const s = String(str).trim();

//   let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/); // YYYY-MM-DD
//   if (m) return `${m[3]}/${m[2]}/${m[1]}`;

//   m = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})/); // D.M.YYYY / D/M/YYYY / D-M-YYYY
//   if (m) {
//     const a = +m[1], b = +m[2];
//     const day = a > 12 ? a : (b > 12 ? b : a); // if first part can't be a month, treat it as the day as-is
//     const mon = a > 12 ? b : (b > 12 ? a : b);
//     return `${String(day).padStart(2, "0")}/${String(mon).padStart(2, "0")}/${m[3]}`;
//   }

//   return s; // unrecognized format — show whatever was extracted rather than nothing
// }

// // ── Sub-components ─────────────────────────────────────────────────────────────

// export function Field({ label, value, wide, warning }) {
//   return (
//     <div className="card-field" style={wide ? { gridColumn: "1 / -1" } : {}}>
//       <div className="card-field-label">{label}</div>
//       <div
//         className={`card-field-value${!value ? " null-val" : ""}`}
//         title={value || ""}
//         style={wide ? { whiteSpace: "normal", wordBreak: "break-word" } : {}}
//       >
//         {value || "—"}
//         {warning && value && <span className="gst-unverified-badge" title={warning}>⚠</span>}
//       </div>
//     </div>
//   );
// }

// export const tdStyle = {
//   padding: "5px 10px",
//   color: "var(--text)",
//   fontFamily: "var(--mono)",
//   whiteSpace: "nowrap",
// };

// export function ItemsTable({ items, discountPercent, invoiceDate }) {
//   if (!items || items.length === 0) return null;
//   const showDiscount   = discountPercent != null && discountPercent !== "";
//   const dateLabel = formatInvoiceDateDMY(invoiceDate || items[0]?.invoice_date);
//   const hasItemCgst    = items.some(it => it.cgst_percent || it.cgst_amount);
//   const hasItemSgst    = items.some(it => it.sgst_percent || it.sgst_amount);
//   const hasItemIgst    = items.some(it => it.igst_percent || it.igst_amount);
//   const hasItemDiscount = items.some(it => it.discount_percent || it.discount_amount);
//   const hasUnit         = items.some(it => it.quantity_unit);

//   const cols = [
//     "HSN", "Material Code", "Description", "Qty",
//     ...(hasUnit ? ["Unit"] : []),
//     "Rate",
//     ...(showDiscount ? ["Disc %"] : []),
//     ...(hasItemDiscount ? ["Item Disc"] : []),
//     ...(hasItemCgst ? ["CGST"] : []),
//     ...(hasItemSgst ? ["SGST"] : []),
//     ...(hasItemIgst ? ["IGST"] : []),
//     "Amount",
//   ];

//   const fmtGst = (pct, amt) => {
//     if (!pct && !amt) return "—";
//     if (pct && amt) return `${pct}% (${amt})`;
//     return pct ? `${pct}%` : amt;
//   };
//   const fmtDisc = (pct, amt) => {
//     if (!pct && !amt) return "—";
//     if (pct && amt) return `${pct}% (${amt})`;
//     return pct ? `${pct}%` : amt;
//   };

//   return (
//     <div style={{ marginTop: 12 }}>
//       <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", color: "var(--text3)", marginBottom: 6 }}>
//         Line Items{dateLabel ? ` — Invoice Date: ${dateLabel}` : ""} ({items.length}){showDiscount && <span style={{ marginLeft: 8, color: "var(--accent2)", fontWeight: 700 }}>· Disc: {discountPercent}%</span>}
//       </div>
//       <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid var(--border)" }}>
//         <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
//           <thead>
//             <tr style={{ background: "var(--surface2)" }}>
//               {cols.map(h => (
//                 <th key={h} style={{
//                   padding: "5px 10px", textAlign: "left", fontWeight: 700,
//                   color: "var(--text2)", borderBottom: "1px solid var(--border)",
//                   whiteSpace: "nowrap", fontSize: 10, textTransform: "uppercase", letterSpacing: ".4px",
//                 }}>{h}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {items.map((item, i) => (
//               <tr key={item.id ?? i} style={{ borderBottom: i < items.length - 1 ? "1px solid var(--border)" : "none" }}>
//                 <td style={tdStyle}>{item.hsn_code || "—"}</td>
//                 <td style={tdStyle}>{item.material_code || "—"}</td>
//                 <td style={{ ...tdStyle, maxWidth: 180, whiteSpace: "normal", wordBreak: "break-word" }}>{item.description || "—"}</td>
//                 <td style={tdStyle}>{item.quantity || "—"}</td>
//                 {hasUnit && <td style={tdStyle}>{item.quantity_unit || "—"}</td>}
//                 <td style={tdStyle}>{item.rate || "—"}</td>
//                 {showDiscount && <td style={{ ...tdStyle, color: "var(--accent2)", fontWeight: 600 }}>{discountPercent}%</td>}
//                 {hasItemDiscount && <td style={{ ...tdStyle, color: "var(--accent2)" }}>{fmtDisc(item.discount_percent, item.discount_amount)}</td>}
//                 {hasItemCgst && <td style={tdStyle}>{fmtGst(item.cgst_percent, item.cgst_amount)}</td>}
//                 {hasItemSgst && <td style={tdStyle}>{fmtGst(item.sgst_percent, item.sgst_amount)}</td>}
//                 {hasItemIgst && <td style={tdStyle}>{fmtGst(item.igst_percent, item.igst_amount)}</td>}
//                 <td style={{ ...tdStyle, fontWeight: 600, color: "var(--accent)" }}>{item.amount || "—"}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export function DiscountsTable({ discountsJson }) {
//   let discounts = [];
//   try {
//     discounts = discountsJson ? JSON.parse(discountsJson) : [];
//   } catch {
//     discounts = [];
//   }
//   if (!discounts.length) return null;

//   return (
//     <div style={{ marginTop: 12 }}>
//       <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", color: "var(--text3)", marginBottom: 6 }}>
//         Discounts ({discounts.length})
//       </div>
//       <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid var(--border)" }}>
//         <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
//           <thead>
//             <tr style={{ background: "var(--surface2)" }}>
//               {["Label", "Percent", "Amount"].map(h => (
//                 <th key={h} style={{
//                   padding: "5px 10px", textAlign: "left", fontWeight: 700,
//                   color: "var(--text2)", borderBottom: "1px solid var(--border)",
//                   whiteSpace: "nowrap", fontSize: 10, textTransform: "uppercase", letterSpacing: ".4px",
//                 }}>{h}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {discounts.map((d, i) => (
//               <tr key={i} style={{ borderBottom: i < discounts.length - 1 ? "1px solid var(--border)" : "none" }}>
//                 <td style={tdStyle}>{d.label || "—"}</td>
//                 <td style={tdStyle}>{d.percent ? `${d.percent}%` : "—"}</td>
//                 <td style={{ ...tdStyle, fontWeight: 600, color: "var(--accent2)" }}>{d.amount || "—"}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// // ── Edit Modal ───────────────────────────────────────────────────────────────

// export const EDIT_SECTIONS = SECTIONS.filter(s => s !== "Audit");
// // Mirrors extractor.py's is_valid_gstin_checksum() (Luhn mod-36) so the edit
// // form can show live feedback while the user types a correction, rather than
// // only showing the stale flag computed at extraction time.
// const GSTIN_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
// export function isValidGstinChecksum(gstin) {
//   if (!gstin || gstin.length !== 15) return false;
//   const g = gstin.toUpperCase();
//   if ([...g].some(ch => !GSTIN_CHARS.includes(ch))) return false;

//   let factor = 2, total = 0;
//   for (let i = 13; i >= 0; i--) {
//     const code = GSTIN_CHARS.indexOf(g[i]);
//     let d = code * factor;
//     d = Math.floor(d / 36) + (d % 36);
//     total += d;
//     factor = factor === 2 ? 1 : 2;
//   }
//   const checkCode = (36 - (total % 36)) % 36;
//   return GSTIN_CHARS[checkCode] === g[14];
// }

// export const MULTILINE_FIELDS = new Set(["seller_address", "buyer_address", "consignee_address", "amount_words"]);
// export const EMPTY_ITEM = {
//   hsn_code: "", material_code: "", description: "", quantity: "", quantity_unit: "",
//   rate: "", amount: "",
//   cgst_percent: "", cgst_amount: "", sgst_percent: "", sgst_amount: "",
//   igst_percent: "", igst_amount: "", discount_percent: "", discount_amount: "",
// };

// export const editInputStyle = {
//   background: "var(--surface2)", border: "1px solid var(--border)",
//   borderRadius: 6, padding: "6px 10px", fontSize: 13,
//   color: "var(--text)", outline: "none", fontFamily: "inherit", width: "100%",
// };

// export function EditModal({ row, onClose, onSaved }) {
//   const [form, setForm] = useState(() => {
//     const init = {};
//     HEADER_COLUMNS.forEach(f => {
//       if (f.section !== "Audit") init[f.key] = row[f.key] ?? "";
//     });
//     return init;
//   });
//   const [items, setItems] = useState(() =>
//     (row.items || []).map(it => ({
//       hsn_code: it.hsn_code ?? "",
//       material_code: it.material_code ?? "",
//       description: it.description ?? "",
//       quantity: it.quantity ?? "",
//       quantity_unit: it.quantity_unit ?? "",
//       rate: it.rate ?? "",
//       amount: it.amount ?? "",
//       cgst_percent: it.cgst_percent ?? "",
//       cgst_amount: it.cgst_amount ?? "",
//       sgst_percent: it.sgst_percent ?? "",
//       sgst_amount: it.sgst_amount ?? "",
//       igst_percent: it.igst_percent ?? "",
//       igst_amount: it.igst_amount ?? "",
//       discount_percent: it.discount_percent ?? "",
//       discount_amount: it.discount_amount ?? "",
//     }))
//   );
//   const [expandedItem, setExpandedItem] = useState(null); // idx of item with tax/discount row open
//   const [saving, setSaving] = useState(false);

//   const setField     = (key, value) => setForm(p => ({ ...p, [key]: value }));
//   const setItemField  = (idx, key, value) => setItems(prev => prev.map((it, i) => (i === idx ? { ...it, [key]: value } : it)));
//   const addItem       = () => setItems(prev => [...prev, { ...EMPTY_ITEM }]);
//   const removeItem    = idx => setItems(prev => prev.filter((_, i) => i !== idx));

//   const save = async () => {
//     setSaving(true);
//     try {
//       // invoice_no / invoice_date on each item mirror the invoice header's
//       // values — keep them in sync in case either was edited too.
//       const itemsWithHeaderRefs = items.map(it => ({
//         ...it,
//         invoice_no: form.invoice_no,
//         invoice_date: form.invoice_date,
//       }));
//       await axios.put(`/api/invoices/${row.id}`, { ...form, items: itemsWithHeaderRefs });
//       toast.success("Invoice updated");
//       onSaved({ ...row, ...form, items: itemsWithHeaderRefs });
//       onClose();
//     } catch (e) {
//       toast.error(e.response?.data?.error || "Save failed");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="modal-backdrop" onClick={onClose}>
//       <div className="modal" style={{ width: 780, maxHeight: "85vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>Edit Invoice — {row.invoice_no || row.id}</h3>
//           <button className="modal-close" onClick={onClose}>×</button>
//         </div>
//         <div className="modal-body">

//           {EDIT_SECTIONS.map(section => {
//             const cols = HEADER_COLUMNS.filter(c => c.section === section);
//             return (
//               <div key={section} style={{ marginBottom: 18 }}>
//                 <div style={{
//                   fontSize: 10, fontWeight: 700, textTransform: "uppercase",
//                   letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
//                   paddingBottom: 4, borderBottom: "1px solid var(--border)",
//                 }}>{section}</div>
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 16px" }}>
//                   {cols.map(f => (
//                     <div
//                       key={f.key}
//                       style={{
//                         display: "flex", flexDirection: "column", gap: 4,
//                         ...(MULTILINE_FIELDS.has(f.key) ? { gridColumn: "1 / -1" } : {}),
//                       }}
//                     >
//                       <label style={{ fontSize: 10, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px" }}>
//                         {f.label}
//                       </label>
//                       {MULTILINE_FIELDS.has(f.key) ? (
//                         <textarea
//                           value={form[f.key]}
//                           onChange={e => setField(f.key, e.target.value)}
//                           rows={2}
//                           style={{ ...editInputStyle, resize: "vertical" }}
//                         />
//                       ) : (
//                         <input
//                           value={form[f.key]}
//                           onChange={e => setField(f.key, e.target.value)}
//                           style={editInputStyle}
//                         />
//                       )}
//                       {(f.key === "seller_gst" || f.key === "buyer_gst") && form[f.key] && !isValidGstinChecksum(form[f.key]) && (
//                         <span style={{ fontSize: 11, color: "var(--warn)", fontWeight: 600 }}>
//                           ⚠ Doesn't pass GSTIN checksum — please verify against the source document
//                         </span>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             );
//           })}

//           {/* Line items editor */}
//           <div style={{ marginBottom: 8 }}>
//             <div style={{
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//               fontSize: 10, fontWeight: 700, textTransform: "uppercase",
//               letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
//               paddingBottom: 4, borderBottom: "1px solid var(--border)",
//             }}>
//               <span>
//                 Line Items ({items.length})
//                 {form.invoice_date && (
//                   <span style={{ marginLeft: 8, color: "var(--text3)", fontWeight: 600, textTransform: "none", letterSpacing: 0 }}>
//                     — Invoice Date: {formatInvoiceDateDMY(form.invoice_date)}
//                   </span>
//                 )}
//               </span>
//               <button
//                 onClick={addItem}
//                 style={{
//                   fontSize: 11, fontWeight: 600, color: "var(--accent2)", background: "transparent",
//                   border: "1px solid rgba(92,78,232,.3)", borderRadius: 6, padding: "3px 9px", cursor: "pointer",
//                 }}
//               >
//                 + Add Item
//               </button>
//             </div>

//             {items.length === 0 ? (
//               <p style={{ fontSize: 12, color: "var(--text3)" }}>No line items yet. Click "+ Add Item" to add one.</p>
//             ) : (
//               <>
//                 <div style={{
//                   display: "grid", gridTemplateColumns: "85px 100px 1fr 64px 64px 85px 95px 60px 28px",
//                   gap: 6, padding: "0 8px 4px",
//                   fontSize: 10, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".4px",
//                 }}>
//                   <span>HSN</span><span>Material Code</span><span>Description</span>
//                   <span>Qty</span><span>Unit</span><span>Rate</span><span>Amount</span><span>Tax/Disc</span><span />
//                 </div>
//                 <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
//                   {items.map((item, idx) => {
//                     const hasTaxOrDisc = item.cgst_percent || item.cgst_amount || item.sgst_percent || item.sgst_amount ||
//                                          item.igst_percent || item.igst_amount || item.discount_percent || item.discount_amount;
//                     return (
//                     <div key={idx}>
//                       <div style={{
//                         display: "grid", gridTemplateColumns: "85px 100px 1fr 64px 64px 85px 95px 60px 28px",
//                         gap: 6, alignItems: "center",
//                         padding: 8, borderRadius: 8, background: "var(--surface2)", border: "1px solid var(--border)",
//                       }}>
//                         <input value={item.hsn_code}      onChange={e => setItemField(idx, "hsn_code", e.target.value)}      style={editInputStyle} />
//                         <input value={item.material_code} onChange={e => setItemField(idx, "material_code", e.target.value)} style={editInputStyle} />
//                         <input value={item.description}   onChange={e => setItemField(idx, "description", e.target.value)}   style={editInputStyle} />
//                         <input value={item.quantity}       onChange={e => setItemField(idx, "quantity", e.target.value)}       style={editInputStyle} />
//                         <input value={item.quantity_unit}  onChange={e => setItemField(idx, "quantity_unit", e.target.value)}  style={editInputStyle} placeholder="UOM" />
//                         <input value={item.rate}           onChange={e => setItemField(idx, "rate", e.target.value)}           style={editInputStyle} />
//                         <input value={item.amount}         onChange={e => setItemField(idx, "amount", e.target.value)}         style={editInputStyle} />
//                         <button
//                           onClick={() => setExpandedItem(p => (p === idx ? null : idx))}
//                           title="Edit per-item GST / discount"
//                           style={{
//                             fontSize: 10, fontWeight: 600, padding: "5px 6px", borderRadius: 6,
//                             border: `1px solid ${hasTaxOrDisc ? "var(--accent2)" : "var(--border)"}`,
//                             background: hasTaxOrDisc ? "rgba(92,78,232,.08)" : "transparent",
//                             color: hasTaxOrDisc ? "var(--accent2)" : "var(--text3)", cursor: "pointer",
//                           }}
//                         >
//                           {expandedItem === idx ? "▲" : "▼"}
//                         </button>
//                         <button
//                           onClick={() => removeItem(idx)}
//                           title="Remove item"
//                           style={{
//                             width: 24, height: 24, borderRadius: 6, border: "1px solid rgba(220,38,38,.3)",
//                             background: "transparent", color: "var(--err)", cursor: "pointer", fontSize: 14, lineHeight: 1,
//                           }}
//                         >×</button>
//                       </div>

//                       {expandedItem === idx && (
//                         <div style={{
//                           marginTop: 4, padding: 10, borderRadius: 8,
//                           background: "rgba(92,78,232,.05)", border: "1px dashed rgba(92,78,232,.25)",
//                           display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8,
//                         }}>
//                           {[
//                             ["CGST %", "cgst_percent"], ["CGST Amt", "cgst_amount"],
//                             ["SGST %", "sgst_percent"], ["SGST Amt", "sgst_amount"],
//                             ["IGST %", "igst_percent"], ["IGST Amt", "igst_amount"],
//                             ["Disc %", "discount_percent"], ["Disc Amt", "discount_amount"],
//                           ].map(([label, key]) => (
//                             <div key={key} style={{ display: "flex", flexDirection: "column", gap: 3 }}>
//                               <label style={{ fontSize: 9, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase" }}>{label}</label>
//                               <input
//                                 value={item[key]}
//                                 onChange={e => setItemField(idx, key, e.target.value)}
//                                 style={{ ...editInputStyle, fontSize: 12, padding: "5px 8px" }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                     );
//                   })}
//                 </div>
//               </>
//             )}
//           </div>

//           <div style={{ marginTop: 20, display: "flex", gap: 10, justifyContent: "flex-end" }}>
//             <button className="btn-ghost" onClick={onClose}>Cancel</button>
//             <button className="btn-primary" onClick={save} disabled={saving}>
//               {saving ? "Saving…" : "Save Changes"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Detail Side Panel ───────────────────────────────────────────────────────────

// export function DetailPanel({ row, onClose }) {
//   const f = v => (v != null && v !== "" ? String(v) : null);
//   const UNVERIFIED_FLAG_FOR = { seller_gst: "seller_gst_unverified", buyer_gst: "buyer_gst_unverified" };

//   return (
//     <div className="detail-panel">
//       <div className="detail-panel-header">
//         <h3>Invoice — {f(row.invoice_no) || "Details"}</h3>
//         <button className="detail-panel-close" onClick={onClose} title="Close">×</button>
//       </div>
//       <div className="detail-panel-body">
//         {SECTIONS.map(section => {
//           const cols   = HEADER_COLUMNS.filter(c => c.section === section);
//           const filled = cols.filter(c => f(row[c.key]));
//           if (!filled.length) return null;
//           return (
//             <div key={section} style={{ marginBottom: 16 }}>
//               <div style={{
//                 fontSize: 10, fontWeight: 700, textTransform: "uppercase",
//                 letterSpacing: ".6px", color: "var(--accent)", marginBottom: 6,
//                 paddingBottom: 4, borderBottom: "1px solid var(--border)",
//               }}>{section}</div>
//               {filled.map(col => {
//                 const flagKey = UNVERIFIED_FLAG_FOR[col.key];
//                 const isUnverified = Boolean(flagKey && row[flagKey]);
//                 return (
//                   <div key={col.key} className="detail-row">
//                     <span className="detail-label">{col.label}</span>
//                     <span className="detail-value">
//                       {row[col.key]}
//                       {isUnverified && (
//                         <span className="gst-unverified-badge" title="This GSTIN failed checksum validation — likely misread during extraction. Please verify against the source document.">
//                           ⚠ Unverified
//                         </span>
//                       )}
//                     </span>
//                   </div>
//                 );
//               })}
//             </div>
//           );
//         })}

//         {/* Items section */}
//         {row.items?.length > 0 && (
//           <div>
//             <div style={{
//               fontSize: 10, fontWeight: 700, textTransform: "uppercase",
//               letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
//               paddingBottom: 4, borderBottom: "1px solid var(--border)",
//             }}>Line Items</div>
//             <ItemsTable items={row.items} discountPercent={row.discount_percent} invoiceDate={row.invoice_date} />
//           </div>
//         )}

//         {/* Discounts section */}
//         {row.discounts_json && (
//           <div style={{ marginTop: 16 }}>
//             <div style={{
//               fontSize: 10, fontWeight: 700, textTransform: "uppercase",
//               letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
//               paddingBottom: 4, borderBottom: "1px solid var(--border)",
//             }}>Discounts</div>
//             <DiscountsTable discountsJson={row.discounts_json} />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// // ── Confirm Modal ───────────────────────────────────────────────────────────────

// export function ConfirmModal({ title, message, onConfirm, onCancel }) {
//   return (
//     <div className="modal-backdrop" onClick={onCancel}>
//       <div className="modal" style={{ width: 400 }} onClick={e => e.stopPropagation()}>
//         <div className="modal-header">
//           <h3>{title}</h3>
//           <button className="modal-close" onClick={onCancel}>×</button>
//         </div>
//         <div className="modal-body">
//           <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.5 }}>{message}</p>
//           <div style={{ marginTop: 20, display: "flex", gap: 10, justifyContent: "flex-end" }}>
//             <button className="btn-ghost" onClick={onCancel}>No</button>
//             <button
//               className="btn-primary"
//               style={{ width: "auto", padding: "8px 20px", background: "var(--err)", boxShadow: "none" }}
//               onClick={onConfirm}
//             >
//               Yes, Delete
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Shared delete-via-API helper ────────────────────────────────────────────────

// export async function deleteInvoices(ids) {
//   await Promise.all(ids.map(id => axios.delete(`/api/invoices/${id}`)));
// }




















import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

// Header-level columns for the detail panel / edit modal — shared so both the
// main grid and the History page render/edit the exact same fields.
export const HEADER_COLUMNS = [
  { key: "invoice_no",          label: "Invoice No.",            section: "Invoice" },
  { key: "invoice_date",        label: "Invoice Date",           section: "Invoice" },
  { key: "bill_no",             label: "Bill No.",               section: "Invoice" },
  { key: "contract_no",         label: "Contract No.",           section: "Invoice" },
  { key: "contract_date",       label: "Contract Date",          section: "Invoice" },
  { key: "delivery_order_no",   label: "Delivery Order No.",     section: "Invoice" },
  { key: "buyer_order_no",      label: "Buyer/Broker Order No.", section: "Invoice" },
  { key: "buyer_order_date",    label: "Buyer Order Date",       section: "Invoice" },
  { key: "seller_name",         label: "Seller / Vendor",        section: "Seller" },
  { key: "seller_address",      label: "Seller Address",         section: "Seller" },
  { key: "seller_gst",          label: "Seller GSTIN",           section: "Seller" },
  { key: "seller_pan",          label: "Seller PAN",             section: "Seller" },
  { key: "cin_no",              label: "CIN No.",                section: "Seller" },
  { key: "seller_msme",         label: "Seller MSME / Udyam No.", section: "Seller" },
  { key: "seller_contact_no",   label: "Seller Contact No.",     section: "Seller" },
  { key: "seller_email",        label: "Seller Email",           section: "Seller" },
  { key: "seller_website",      label: "Seller Website",         section: "Seller" },
  { key: "buyer_name",          label: "Buyer",                  section: "Buyer" },
  { key: "buyer_address",       label: "Buyer Address",          section: "Buyer" },
  { key: "buyer_gst",           label: "Buyer GSTIN",            section: "Buyer" },
  { key: "buyer_pan",           label: "Buyer PAN",              section: "Buyer" },
  { key: "buyer_msme",          label: "Buyer MSME / Udyam No.", section: "Buyer" },
  { key: "buyer_contact_no",    label: "Buyer Contact No.",      section: "Buyer" },
  { key: "buyer_email",         label: "Buyer Email",            section: "Buyer" },
  { key: "buyer_website",       label: "Buyer Website",          section: "Buyer" },
  { key: "seller_bank_name",          label: "Bank Name",              section: "Seller Bank" },
  { key: "seller_bank_account_name",  label: "Account Holder Name",    section: "Seller Bank" },
  { key: "seller_bank_account_no",    label: "Account Number",         section: "Seller Bank" },
  { key: "seller_bank_ifsc",          label: "IFSC Code",              section: "Seller Bank" },
  { key: "seller_bank_swift",         label: "SWIFT Code",             section: "Seller Bank" },
  { key: "seller_bank_address",       label: "Bank Address",           section: "Seller Bank" },
  { key: "seller_bank_contact",       label: "Bank Contact No.",       section: "Seller Bank" },
  { key: "buyer_bank_name",          label: "Bank Name",              section: "Buyer Bank" },
  { key: "buyer_bank_account_name",  label: "Account Holder Name",    section: "Buyer Bank" },
  { key: "buyer_bank_account_no",    label: "Account Number",         section: "Buyer Bank" },
  { key: "buyer_bank_ifsc",          label: "IFSC Code",              section: "Buyer Bank" },
  { key: "buyer_bank_swift",         label: "SWIFT Code",             section: "Buyer Bank" },
  { key: "buyer_bank_address",       label: "Bank Address",           section: "Buyer Bank" },
  { key: "buyer_bank_contact",       label: "Bank Contact No.",       section: "Buyer Bank" },
  { key: "consignee_name",      label: "Consignee",              section: "Consignee" },
  { key: "consignee_address",   label: "Consignee Address",      section: "Consignee" },
  { key: "terms_of_payment",    label: "Terms of Payment",       section: "Terms" },
  { key: "terms_of_delivery",   label: "Terms of Delivery",      section: "Terms" },
  { key: "place_of_supply",     label: "Place of Supply",        section: "Terms" },
  { key: "irn_no",              label: "IRN No.",                section: "Terms" },
  { key: "e_way_bill_no",       label: "E-Way Bill No.",         section: "Terms" },
  { key: "e_way_bill_validity", label: "E-Way Bill Validity",    section: "Terms" },
  { key: "vehicle_no",          label: "Vehicle / Truck No.",    section: "Transport" },
  { key: "dc_no",               label: "DC No.",                 section: "Transport" },
  { key: "rr_lr_no",            label: "RR / LR No.",            section: "Transport" },
  { key: "total_inr_figures",   label: "Total INR (Figures)",    section: "Amount" },
  { key: "amount_words",        label: "Amount (Words)",         section: "Amount" },
  { key: "discount_percent",    label: "Discount (%)",           section: "Amount" },
  { key: "cgst_percent",        label: "CGST (%)",               section: "Amount" },
  { key: "cgst_amount",         label: "CGST Amount",            section: "Amount" },
  { key: "sgst_percent",        label: "SGST (%)",               section: "Amount" },
  { key: "sgst_amount",         label: "SGST Amount",            section: "Amount" },
  { key: "igst_percent",        label: "IGST (%)",               section: "Amount" },
  { key: "igst_amount",         label: "IGST Amount",            section: "Amount" },
  { key: "total_gst_amount",    label: "Total GST Amount",       section: "Amount" },
  { key: "uploaded_by",         label: "Uploaded By",            section: "Audit" },
  { key: "uploaded_time_ist",   label: "Uploaded Time (IST)",    section: "Audit" },
];

export const SECTIONS = ["Invoice", "Seller", "Seller Bank", "Buyer", "Buyer Bank", "Consignee", "Terms", "Transport", "Amount", "Audit"];

// ── CSV helpers ────────────────────────────────────────────────────────────────

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function invoicesToFlatCsv(invoices) {
  const hdrKeys  = HEADER_COLUMNS.map(c => c.key); // already excludes id
  const itemKeys = [
    "hsn_code", "material_code", "description", "quantity", "quantity_unit", "rate", "amount",
    "cgst_percent", "cgst_amount", "sgst_percent", "sgst_amount",
    "igst_percent", "igst_amount", "discount_percent", "discount_amount",
  ]; // excludes id, invoice_id
  const allKeys  = [...hdrKeys, "discounts_summary", ...itemKeys];
  const header   = allKeys.map(k => `"${k}"`).join(",");

  const flattenDiscounts = (inv) => {
    try {
      const list = inv.discounts_json ? JSON.parse(inv.discounts_json) : [];
      if (!list.length) return "";
      return list.map(d => `${d.label || "Discount"}: ${d.percent ? d.percent + "%" : ""}${d.amount ? ` (${d.amount})` : ""}`).join(" | ");
    } catch {
      return "";
    }
  };

  const lines = [];
  for (const inv of invoices) {
    const items = inv.items?.length ? inv.items : [{}];
    const discountsSummary = flattenDiscounts(inv);
    for (const item of items) {
      const row = allKeys.map(k => {
        if (k === "discounts_summary") return `"${discountsSummary.replace(/"/g, '""')}"`;
        const v = k in item ? item[k] : inv[k];
        return `"${String(v ?? "").replace(/"/g, '""')}"`;
      });
      lines.push(row.join(","));
    }
  }
  return new Blob(["\uFEFF" + [header, ...lines].join("\n")], { type: "text/csv" });
}

export function exportSingleInvoice(row) {
  const blob = invoicesToFlatCsv([row]);
  const safe = (row.invoice_no || `invoice_${row.id}`).replace(/[^a-z0-9]/gi, "_").slice(0, 40);
  downloadBlob(blob, `${safe}_${Date.now()}.csv`);
  toast.success(`Exported invoice ${row.invoice_no || row.id}`);
}

export function exportSellerInvoices(sellerName, sellerRows) {
  const blob = invoicesToFlatCsv(sellerRows);
  const safe = sellerName.replace(/[^a-z0-9]/gi, "_").slice(0, 40);
  downloadBlob(blob, `invoices_${safe}_${Date.now()}.csv`);
  toast.success(`Exported ${sellerRows.length} invoice(s) for ${sellerName}`);
}

// ── Date helpers ───────────────────────────────────────────────────────────────

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function parseInvoiceDate(str) {
  if (!str) return null;
  const s = String(str).trim();
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return { y: +m[1], mo: +m[2] };
  m = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})/);
  if (m) {
    const a = +m[1], b = +m[2];
    if (a > 12) return { y: +m[3], mo: b };
    return { y: +m[3], mo: a };
  }
  return null;
}

export function getRowMonthKey(row) {
  const d = parseInvoiceDate(row.invoice_date) || parseInvoiceDate(row.created_at);
  if (!d) return null;
  return `${d.y}-${String(d.mo).padStart(2, "0")}`;
}

export function monthKeyLabel(key) {
  const [y, m] = key.split("-").map(Number);
  return `${MONTH_NAMES[m - 1]} ${y}`;
}

// Formats a stored invoice_date (which may already be in several different
// formats — YYYY-MM-DD, DD.MM.YYYY, DD/MM/YYYY, etc., since it comes straight
// from whatever the source PDF/model produced) into a consistent DD/MM/YYYY
// for display. Falls back to the raw string if it doesn't recognize the
// pattern, rather than hiding a date the user can still read.
export function formatInvoiceDateDMY(str) {
  if (!str) return null;
  const s = String(str).trim();

  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/); // YYYY-MM-DD
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;

  m = s.match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})/); // D.M.YYYY / D/M/YYYY / D-M-YYYY
  if (m) {
    const a = +m[1], b = +m[2];
    const day = a > 12 ? a : (b > 12 ? b : a); // if first part can't be a month, treat it as the day as-is
    const mon = a > 12 ? b : (b > 12 ? a : b);
    return `${String(day).padStart(2, "0")}/${String(mon).padStart(2, "0")}/${m[3]}`;
  }

  return s; // unrecognized format — show whatever was extracted rather than nothing
}

// ── Sub-components ─────────────────────────────────────────────────────────────

export function Field({ label, value, wide, warning }) {
  return (
    <div className="card-field" style={wide ? { gridColumn: "1 / -1" } : {}}>
      <div className="card-field-label">{label}</div>
      <div
        className={`card-field-value${!value ? " null-val" : ""}`}
        title={value || ""}
        style={wide ? { whiteSpace: "normal", wordBreak: "break-word" } : {}}
      >
        {value || "—"}
        {warning && value && <span className="gst-unverified-badge" title={warning}>⚠</span>}
      </div>
    </div>
  );
}

export const tdStyle = {
  padding: "5px 10px",
  color: "var(--text)",
  fontFamily: "var(--mono)",
  whiteSpace: "nowrap",
};

export function ItemsTable({ items, discountPercent, invoiceDate }) {
  if (!items || items.length === 0) return null;
  const showDiscount   = discountPercent != null && discountPercent !== "";
  const dateLabel = formatInvoiceDateDMY(invoiceDate || items[0]?.invoice_date);
  const hasItemCgst    = items.some(it => it.cgst_percent || it.cgst_amount);
  const hasItemSgst    = items.some(it => it.sgst_percent || it.sgst_amount);
  const hasItemIgst    = items.some(it => it.igst_percent || it.igst_amount);
  const hasItemDiscount = items.some(it => it.discount_percent || it.discount_amount);
  const hasUnit         = items.some(it => it.quantity_unit);

  const cols = [
    "HSN", "Material Code", "Description", "Qty",
    ...(hasUnit ? ["Unit"] : []),
    "Rate",
    ...(showDiscount ? ["Disc %"] : []),
    ...(hasItemDiscount ? ["Item Disc"] : []),
    ...(hasItemCgst ? ["CGST"] : []),
    ...(hasItemSgst ? ["SGST"] : []),
    ...(hasItemIgst ? ["IGST"] : []),
    "Amount",
  ];

  const fmtGst = (pct, amt) => {
    if (!pct && !amt) return "—";
    if (pct && amt) return `${pct}% (${amt})`;
    return pct ? `${pct}%` : amt;
  };
  const fmtDisc = (pct, amt) => {
    if (!pct && !amt) return "—";
    if (pct && amt) return `${pct}% (${amt})`;
    return pct ? `${pct}%` : amt;
  };

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", color: "var(--text3)", marginBottom: 6 }}>
        Line Items{dateLabel ? ` — Invoice Date: ${dateLabel}` : ""} ({items.length}){showDiscount && <span style={{ marginLeft: 8, color: "var(--accent2)", fontWeight: 700 }}>· Disc: {discountPercent}%</span>}
      </div>
      <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid var(--border)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
          <thead>
            <tr style={{ background: "var(--surface2)" }}>
              {cols.map(h => (
                <th key={h} style={{
                  padding: "5px 10px", textAlign: "left", fontWeight: 700,
                  color: "var(--text2)", borderBottom: "1px solid var(--border)",
                  whiteSpace: "nowrap", fontSize: 10, textTransform: "uppercase", letterSpacing: ".4px",
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={item.id ?? i} style={{ borderBottom: i < items.length - 1 ? "1px solid var(--border)" : "none" }}>
                <td style={tdStyle}>{item.hsn_code || "—"}</td>
                <td style={tdStyle}>{item.material_code || "—"}</td>
                <td style={{ ...tdStyle, maxWidth: 180, whiteSpace: "normal", wordBreak: "break-word" }}>{item.description || "—"}</td>
                <td style={tdStyle}>{item.quantity || "—"}</td>
                {hasUnit && <td style={tdStyle}>{item.quantity_unit || "—"}</td>}
                <td style={tdStyle}>{item.rate || "—"}</td>
                {showDiscount && <td style={{ ...tdStyle, color: "var(--accent2)", fontWeight: 600 }}>{discountPercent}%</td>}
                {hasItemDiscount && <td style={{ ...tdStyle, color: "var(--accent2)" }}>{fmtDisc(item.discount_percent, item.discount_amount)}</td>}
                {hasItemCgst && <td style={tdStyle}>{fmtGst(item.cgst_percent, item.cgst_amount)}</td>}
                {hasItemSgst && <td style={tdStyle}>{fmtGst(item.sgst_percent, item.sgst_amount)}</td>}
                {hasItemIgst && <td style={tdStyle}>{fmtGst(item.igst_percent, item.igst_amount)}</td>}
                <td style={{ ...tdStyle, fontWeight: 600, color: "var(--accent)" }}>{item.amount || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function DiscountsTable({ discountsJson }) {
  let discounts = [];
  try {
    discounts = discountsJson ? JSON.parse(discountsJson) : [];
  } catch {
    discounts = [];
  }
  if (!discounts.length) return null;

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".5px", color: "var(--text3)", marginBottom: 6 }}>
        Discounts ({discounts.length})
      </div>
      <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid var(--border)" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
          <thead>
            <tr style={{ background: "var(--surface2)" }}>
              {["Label", "Percent", "Amount"].map(h => (
                <th key={h} style={{
                  padding: "5px 10px", textAlign: "left", fontWeight: 700,
                  color: "var(--text2)", borderBottom: "1px solid var(--border)",
                  whiteSpace: "nowrap", fontSize: 10, textTransform: "uppercase", letterSpacing: ".4px",
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {discounts.map((d, i) => (
              <tr key={i} style={{ borderBottom: i < discounts.length - 1 ? "1px solid var(--border)" : "none" }}>
                <td style={tdStyle}>{d.label || "—"}</td>
                <td style={tdStyle}>{d.percent ? `${d.percent}%` : "—"}</td>
                <td style={{ ...tdStyle, fontWeight: 600, color: "var(--accent2)" }}>{d.amount || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ── Edit Modal ───────────────────────────────────────────────────────────────

export const EDIT_SECTIONS = SECTIONS.filter(s => s !== "Audit");
// Mirrors extractor.py's is_valid_gstin_checksum() (Luhn mod-36) so the edit
// form can show live feedback while the user types a correction, rather than
// only showing the stale flag computed at extraction time.
const GSTIN_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export function isValidGstinChecksum(gstin) {
  if (!gstin || gstin.length !== 15) return false;
  const g = gstin.toUpperCase();
  if ([...g].some(ch => !GSTIN_CHARS.includes(ch))) return false;

  let factor = 2, total = 0;
  for (let i = 13; i >= 0; i--) {
    const code = GSTIN_CHARS.indexOf(g[i]);
    let d = code * factor;
    d = Math.floor(d / 36) + (d % 36);
    total += d;
    factor = factor === 2 ? 1 : 2;
  }
  const checkCode = (36 - (total % 36)) % 36;
  return GSTIN_CHARS[checkCode] === g[14];
}

export const MULTILINE_FIELDS = new Set(["seller_address", "buyer_address", "consignee_address", "amount_words"]);
export const EMPTY_ITEM = {
  hsn_code: "", material_code: "", description: "", quantity: "", quantity_unit: "",
  rate: "", amount: "",
  cgst_percent: "", cgst_amount: "", sgst_percent: "", sgst_amount: "",
  igst_percent: "", igst_amount: "", discount_percent: "", discount_amount: "",
};

export const editInputStyle = {
  background: "var(--surface2)", border: "1px solid var(--border)",
  borderRadius: 6, padding: "6px 10px", fontSize: 13,
  color: "var(--text)", outline: "none", fontFamily: "inherit", width: "100%",
};

export function EditModal({ row, onClose, onSaved }) {
  const [form, setForm] = useState(() => {
    const init = {};
    HEADER_COLUMNS.forEach(f => {
      if (f.section !== "Audit") init[f.key] = row[f.key] ?? "";
    });
    return init;
  });
  const [items, setItems] = useState(() =>
    (row.items || []).map(it => ({
      hsn_code: it.hsn_code ?? "",
      material_code: it.material_code ?? "",
      description: it.description ?? "",
      quantity: it.quantity ?? "",
      quantity_unit: it.quantity_unit ?? "",
      rate: it.rate ?? "",
      amount: it.amount ?? "",
      cgst_percent: it.cgst_percent ?? "",
      cgst_amount: it.cgst_amount ?? "",
      sgst_percent: it.sgst_percent ?? "",
      sgst_amount: it.sgst_amount ?? "",
      igst_percent: it.igst_percent ?? "",
      igst_amount: it.igst_amount ?? "",
      discount_percent: it.discount_percent ?? "",
      discount_amount: it.discount_amount ?? "",
    }))
  );
  const [expandedItem, setExpandedItem] = useState(null); // idx of item with tax/discount row open
  const [saving, setSaving] = useState(false);

  const setField     = (key, value) => setForm(p => ({ ...p, [key]: value }));
  const setItemField  = (idx, key, value) => setItems(prev => prev.map((it, i) => (i === idx ? { ...it, [key]: value } : it)));
  const addItem       = () => setItems(prev => [...prev, { ...EMPTY_ITEM }]);
  const removeItem    = idx => setItems(prev => prev.filter((_, i) => i !== idx));

  const save = async () => {
    setSaving(true);
    try {
      // invoice_no / invoice_date on each item mirror the invoice header's
      // values — keep them in sync in case either was edited too.
      const itemsWithHeaderRefs = items.map(it => ({
        ...it,
        invoice_no: form.invoice_no,
        invoice_date: form.invoice_date,
      }));
      await axios.put(`/api/invoices/${row.id}`, { ...form, items: itemsWithHeaderRefs });
      toast.success("Invoice updated");
      onSaved({ ...row, ...form, items: itemsWithHeaderRefs });
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.error || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" style={{ width: 780, maxHeight: "85vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Edit Invoice — {row.invoice_no || row.id}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">

          {EDIT_SECTIONS.map(section => {
            const cols = HEADER_COLUMNS.filter(c => c.section === section);
            return (
              <div key={section} style={{ marginBottom: 18 }}>
                <div style={{
                  fontSize: 10, fontWeight: 700, textTransform: "uppercase",
                  letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
                  paddingBottom: 4, borderBottom: "1px solid var(--border)",
                }}>{section}</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 16px" }}>
                  {cols.map(f => (
                    <div
                      key={f.key}
                      style={{
                        display: "flex", flexDirection: "column", gap: 4,
                        ...(MULTILINE_FIELDS.has(f.key) ? { gridColumn: "1 / -1" } : {}),
                      }}
                    >
                      <label style={{ fontSize: 10, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px" }}>
                        {f.label}
                      </label>
                      {MULTILINE_FIELDS.has(f.key) ? (
                        <textarea
                          value={form[f.key]}
                          onChange={e => setField(f.key, e.target.value)}
                          rows={2}
                          style={{ ...editInputStyle, resize: "vertical" }}
                        />
                      ) : (
                        <input
                          value={form[f.key]}
                          onChange={e => setField(f.key, e.target.value)}
                          style={editInputStyle}
                        />
                      )}
                      {(f.key === "seller_gst" || f.key === "buyer_gst") && form[f.key] && !isValidGstinChecksum(form[f.key]) && (
                        <span style={{ fontSize: 11, color: "var(--warn)", fontWeight: 600 }}>
                          ⚠ Doesn't pass GSTIN checksum — please verify against the source document
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

          {/* Line items editor */}
          <div style={{ marginBottom: 8 }}>
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              fontSize: 10, fontWeight: 700, textTransform: "uppercase",
              letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
              paddingBottom: 4, borderBottom: "1px solid var(--border)",
            }}>
              <span>
                Line Items ({items.length})
                {form.invoice_date && (
                  <span style={{ marginLeft: 8, color: "var(--text3)", fontWeight: 600, textTransform: "none", letterSpacing: 0 }}>
                    — Invoice Date: {formatInvoiceDateDMY(form.invoice_date)}
                  </span>
                )}
              </span>
              <button
                onClick={addItem}
                style={{
                  fontSize: 11, fontWeight: 600, color: "var(--accent2)", background: "transparent",
                  border: "1px solid rgba(92,78,232,.3)", borderRadius: 6, padding: "3px 9px", cursor: "pointer",
                }}
              >
                + Add Item
              </button>
            </div>

            {items.length === 0 ? (
              <p style={{ fontSize: 12, color: "var(--text3)" }}>No line items yet. Click "+ Add Item" to add one.</p>
            ) : (
              <>
                <div style={{
                  display: "grid", gridTemplateColumns: "85px 100px 1fr 64px 64px 85px 95px 60px 28px",
                  gap: 6, padding: "0 8px 4px",
                  fontSize: 10, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".4px",
                }}>
                  <span>HSN</span><span>Material Code</span><span>Description</span>
                  <span>Qty</span><span>Unit</span><span>Rate</span><span>Amount</span><span>Tax/Disc</span><span />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {items.map((item, idx) => {
                    const hasTaxOrDisc = item.cgst_percent || item.cgst_amount || item.sgst_percent || item.sgst_amount ||
                                         item.igst_percent || item.igst_amount || item.discount_percent || item.discount_amount;
                    return (
                    <div key={idx}>
                      <div style={{
                        display: "grid", gridTemplateColumns: "85px 100px 1fr 64px 64px 85px 95px 60px 28px",
                        gap: 6, alignItems: "center",
                        padding: 8, borderRadius: 8, background: "var(--surface2)", border: "1px solid var(--border)",
                      }}>
                        <input value={item.hsn_code}      onChange={e => setItemField(idx, "hsn_code", e.target.value)}      style={editInputStyle} />
                        <input value={item.material_code} onChange={e => setItemField(idx, "material_code", e.target.value)} style={editInputStyle} />
                        <input value={item.description}   onChange={e => setItemField(idx, "description", e.target.value)}   style={editInputStyle} />
                        <input value={item.quantity}       onChange={e => setItemField(idx, "quantity", e.target.value)}       style={editInputStyle} />
                        <input value={item.quantity_unit}  onChange={e => setItemField(idx, "quantity_unit", e.target.value)}  style={editInputStyle} placeholder="UOM" />
                        <input value={item.rate}           onChange={e => setItemField(idx, "rate", e.target.value)}           style={editInputStyle} />
                        <input value={item.amount}         onChange={e => setItemField(idx, "amount", e.target.value)}         style={editInputStyle} />
                        <button
                          onClick={() => setExpandedItem(p => (p === idx ? null : idx))}
                          title="Edit per-item GST / discount"
                          style={{
                            fontSize: 10, fontWeight: 600, padding: "5px 6px", borderRadius: 6,
                            border: `1px solid ${hasTaxOrDisc ? "var(--accent2)" : "var(--border)"}`,
                            background: hasTaxOrDisc ? "rgba(92,78,232,.08)" : "transparent",
                            color: hasTaxOrDisc ? "var(--accent2)" : "var(--text3)", cursor: "pointer",
                          }}
                        >
                          {expandedItem === idx ? "▲" : "▼"}
                        </button>
                        <button
                          onClick={() => removeItem(idx)}
                          title="Remove item"
                          style={{
                            width: 24, height: 24, borderRadius: 6, border: "1px solid rgba(220,38,38,.3)",
                            background: "transparent", color: "var(--err)", cursor: "pointer", fontSize: 14, lineHeight: 1,
                          }}
                        >×</button>
                      </div>

                      {expandedItem === idx && (
                        <div style={{
                          marginTop: 4, padding: 10, borderRadius: 8,
                          background: "rgba(92,78,232,.05)", border: "1px dashed rgba(92,78,232,.25)",
                          display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8,
                        }}>
                          {[
                            ["CGST %", "cgst_percent"], ["CGST Amt", "cgst_amount"],
                            ["SGST %", "sgst_percent"], ["SGST Amt", "sgst_amount"],
                            ["IGST %", "igst_percent"], ["IGST Amt", "igst_amount"],
                            ["Disc %", "discount_percent"], ["Disc Amt", "discount_amount"],
                          ].map(([label, key]) => (
                            <div key={key} style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                              <label style={{ fontSize: 9, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase" }}>{label}</label>
                              <input
                                value={item[key]}
                                onChange={e => setItemField(idx, key, e.target.value)}
                                style={{ ...editInputStyle, fontSize: 12, padding: "5px 8px" }}
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          <div style={{ marginTop: 20, display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button className="btn-ghost" onClick={onClose}>Cancel</button>
            <button className="btn-primary" onClick={save} disabled={saving}>
              {saving ? "Saving…" : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Detail Side Panel ───────────────────────────────────────────────────────────

export function DetailPanel({ row, onClose }) {
  const f = v => (v != null && v !== "" ? String(v) : null);
  const UNVERIFIED_FLAG_FOR = { seller_gst: "seller_gst_unverified", buyer_gst: "buyer_gst_unverified" };

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <h3>Invoice — {f(row.invoice_no) || "Details"}</h3>
        <button className="detail-panel-close" onClick={onClose} title="Close">×</button>
      </div>
      <div className="detail-panel-body">
        {SECTIONS.map(section => {
          const cols   = HEADER_COLUMNS.filter(c => c.section === section);
          const filled = cols.filter(c => f(row[c.key]));
          if (!filled.length) return null;
          return (
            <div key={section} style={{ marginBottom: 16 }}>
              <div style={{
                fontSize: 10, fontWeight: 700, textTransform: "uppercase",
                letterSpacing: ".6px", color: "var(--accent)", marginBottom: 6,
                paddingBottom: 4, borderBottom: "1px solid var(--border)",
              }}>{section}</div>
              {filled.map(col => {
                const flagKey = UNVERIFIED_FLAG_FOR[col.key];
                const isUnverified = Boolean(flagKey && row[flagKey]);
                return (
                  <div key={col.key} className="detail-row">
                    <span className="detail-label">{col.label}</span>
                    <span className="detail-value">
                      {row[col.key]}
                      {isUnverified && (
                        <span className="gst-unverified-badge" title="This GSTIN failed checksum validation — likely misread during extraction. Please verify against the source document.">
                          ⚠ Unverified
                        </span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          );
        })}

        {/* Items section */}
        {row.items?.length > 0 && (
          <div>
            <div style={{
              fontSize: 10, fontWeight: 700, textTransform: "uppercase",
              letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
              paddingBottom: 4, borderBottom: "1px solid var(--border)",
            }}>Line Items</div>
            <ItemsTable items={row.items} discountPercent={row.discount_percent} invoiceDate={row.invoice_date} />
          </div>
        )}

        {/* Discounts section */}
        {row.discounts_json && (
          <div style={{ marginTop: 16 }}>
            <div style={{
              fontSize: 10, fontWeight: 700, textTransform: "uppercase",
              letterSpacing: ".6px", color: "var(--accent)", marginBottom: 8,
              paddingBottom: 4, borderBottom: "1px solid var(--border)",
            }}>Discounts</div>
            <DiscountsTable discountsJson={row.discounts_json} />
          </div>
        )}
      </div>
    </div>
  );
}

// ── Confirm Modal ───────────────────────────────────────────────────────────────

export function ConfirmModal({ title, message, onConfirm, onCancel, confirmLabel = "Yes", cancelLabel = "No", danger = true }) {
  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" style={{ width: 400 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onCancel}>×</button>
        </div>
        <div className="modal-body">
          <p style={{ fontSize: 14, color: "var(--text2)", lineHeight: 1.5 }}>{message}</p>
          <div style={{ marginTop: 20, display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button className="btn-ghost" onClick={onCancel}>{cancelLabel}</button>
            <button
              className="btn-primary"
              style={{ width: "auto", padding: "8px 20px", background: danger ? "var(--err)" : undefined, boxShadow: "none" }}
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Shared vendor-verification helper ───────────────────────────────────────────

export async function resolveVendorMatch(invoiceId, proceed) {
  const res = await axios.post(`/api/invoices/${invoiceId}/vendor-resolve`, { proceed });
  return res.data;
}

export async function postInvoiceToErp(invoiceId) {
  const res = await axios.post(`/api/invoices/${invoiceId}/post-to-erp`);
  return res.data;
}

// ── Shared delete-via-API helper ────────────────────────────────────────────────

export async function deleteInvoices(ids) {
  await Promise.all(ids.map(id => axios.delete(`/api/invoices/${id}`)));
}